
export const ConfirmPane =function(props:{showConfirm:boolean,confirmClick:Function, confirmMessage:string}){
	if(props.showConfirm===false)return null;
	return(
		<div id='teachers-confirmpane'>
			<div id='teachers-confirmpane-blocker'></div>
			<div id='teachers-confirmpane-pane'>
				<p>{props.confirmMessage}</p>
				<button onClick={()=>{props.confirmClick(true)}} id='teachers-confirmpane-confirm'>Confirm</button>
				<button onClick={()=>{props.confirmClick(false)}} id='teachers-confirmpane-cancel'>Cancel</button>
			</div>
		</div>
	);
}

export const ConfirmPaneLockScroll=function(doLock:boolean){
	if(doLock){
		document.getElementsByTagName('body')[0].style.overflow = 'hidden';
	}else{
		document.getElementsByTagName('body')[0].style.overflow = 'visible';
	}
	
};